import 'amazon-connect-streams'; // Docs: https://github.com/amazon-connect/amazon-connect-streams
import { useRef } from 'react';

import { Button, Flex, Typography } from 'antd';
import useAWSConnect from 'hooks/useAWSConnect';

const Softphone = () => {
  const softphoneRef = useRef();
  const { agentStatus, agentStatusColors, initializeAWSConnect, initialized } =
    useAWSConnect();

  return (
    <>
      <Flex
        style={{
          padding: 'var(--spacing-xxs)',
          backgroundColor: agentStatusColors.background,
        }}
        align="center"
        justify="center"
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
            color: agentStatusColors.foreground,
            whiteSpace: 'nowrap',
          }}
        >
          {agentStatus || 'Not Connected'}
        </Typography.Title>
      </Flex>
      <div
        style={{
          height: '540px',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
        }}
        ref={softphoneRef}
      >
        {!initialized && (
          <Button
            type="primary"
            onClick={() => {
              initializeAWSConnect(softphoneRef.current);
            }}
            style={{ margin: '1rem' }}
          >
            Connect to Dialer
          </Button>
        )}
      </div>
    </>
  );
};

export default Softphone;
